// Baked-in copy of the Smart UART comparison table, taken from the Tixaru
// catalog in Oct 2026. The landing page shows this immediately (and in the
// prerendered HTML) and swaps in live Firestore data once it loads, so the
// table is never blank if that request is slow or blocked.
const R = "/tft/special-displays/smart-uart-display/";
const s = (label, value) => ({ label, value });

const UART_COMPARE_ITEMS = [
  {
    id: "b-1101-qui-0500-bx", partNo: "B-1101-QUI-0500-BX", title: "B-1101-QUI-0500-BX",
    price: null, route: R + "b-1101-qui-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "CTP"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "400 Nits")],
  },
  {
    id: "b-1102-vui-0700-bx", partNo: "B-1102-VUI-0700-BX", title: "B-1102-VUI-0700-BX",
    image: "/landing/uart-display-7-inch-b-1102.jpg",
    price: 4500, route: R + "b-1102-vui-0700-bx",
    specs: [s("DIAGONAL SIZE", "7 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "153.84 x 85.63 mm"), s("DISPLAY INTERFACE", "UART"), s("TFT PIN COUNT", "24"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "400 Nits"), s("OPERATING TEMPERATURE", "-20 to 70 Deg C")],
  },
  {
    id: "b-2292-tun-0500-bx", partNo: "B-2292-TUN-0500-BX", title: "B-2292-TUN-0500-BX",
    price: null, route: R + "b-2292-tun-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "1000 Nits")],
  },
  {
    id: "b-2289-pun-0500-bx", partNo: "B-2289-PUN-0500-BX", title: "B-2289-PUN-0500-BX",
    price: null, route: R + "b-2289-pun-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "RTP"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "400 Nits")],
  },
  {
    id: "b-1126-vui-0500-bx", partNo: "B-1126-VUI-0500-BX", title: "B-1126-VUI-0500-BX",
    price: null, route: R + "b-1126-vui-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "CTP"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "1000 Nits"), s("OPERATING TEMPERATURE", "-20 to 70 Deg C")],
  },
  {
    id: "b-1103-vui-0700-bx", partNo: "B-1103-VUI-0700-BX", title: "B-1103-VUI-0700-BX",
    price: null, route: R + "b-1103-vui-0700-bx",
    specs: [s("DIAGONAL SIZE", "7 Inch"), s("RESOLUTION", "800x480 Pixels"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "CTP"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "1000 Nits"), s("OPERATING TEMPERATURE", "-20 to 70 Deg C")],
  },
  {
    id: "b-1098-vui-0500-bx", partNo: "B-1098-VUI-0500-BX", title: "B-1098-VUI-0500-BX",
    price: null, route: R + "b-1098-vui-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("TOP POLARIZER TYPE", "Anti glare"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "400 Nits")],
  },
  {
    id: "b-2290-pun-0500-bx", partNo: "B-2290-PUN-0500-BX", title: "B-2290-PUN-0500-BX",
    price: null, route: R + "b-2290-pun-0500-bx",
    specs: [s("DIAGONAL SIZE", "5 Inch"), s("RESOLUTION", "800x480 Pixels"), s("ACTIVE AREA", "108.0 x 64.8 mm"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "RTP"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "1000 Nits")],
  },
  {
    id: "b-1100-vun-0700-bx", partNo: "B-1100-VUN-0700-BX", title: "B-1100-VUN-0700-BX",
    price: null, route: R + "b-1100-vun-0700-bx",
    specs: [s("DIAGONAL SIZE", "7 Inch"), s("RESOLUTION", "800x480 Pixels"), s("DISPLAY INTERFACE", "UART"), s("TOUCH PANEL TYPE", "Optional"), s("VIEWING DIRECTION", "All"), s("SURFACE BRIGHTNESS", "1000 Nits"), s("OPERATING TEMPERATURE", "-20 to 70 Deg C")],
  },
];

export default UART_COMPARE_ITEMS;
